import React from 'react';
import { CheckIcon, GiftIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { TrustLine } from './TrustLine';
import { OFFER, SAVINGS } from '../data/offer';
const volumeList = ['Volume 1 — The Foundation', 'Volume 2 — The Vendor Playbook', 'Volume 3 — The Details', 'Volume 4 — The Countdown', 'Volume 5 — The Final Month ★', 'Volume 6 — The Day Itself'];
const bonusList = ['Bonus 1 — First Two Weeks Quick-Start', 'Bonus 2 — Message Swipe File', 'Bonus 3 — Budget & Payments Tracker', 'Bonus 4 — 12-Month Deadline Calendar', 'Bonus 5 — RSVP Tracker'];
export function Pricing() {
  return <section id="pricing" aria-labelledby="pricing-heading" className="w-full bg-ivory" data-id="element-154" data-mp="25tiyh5kb7zqz">
      <div className="max-w-3xl mx-auto px-5 sm:px-8 py-14 sm:py-20" data-id="element-155" data-mp="20rjvhwshf4uk">
        <h2 id="pricing-heading" className="font-serif font-normal text-ink text-[28px] sm:text-[40px] text-center" data-id="element-156" data-mp="3h6lenzihynam">
          Get the complete plan today
        </h2>

        <div className="mt-10 rounded border border-sage/40 bg-white shadow-card" data-id="element-157" data-mp="3w08be0dy786o">
          <div className="border-b border-sage/20 px-6 sm:px-10 py-8 text-center" data-id="element-158" data-mp="4smfitxh0a0d">
            <p className="font-serif font-medium text-ink text-[22px] sm:text-[26px] leading-snug" data-id="element-159" data-mp="9s8rl01kbk7l">
              The 12-Month Wedding Plan™ — Complete Edition
            </p>
            <p className="mt-2 text-[17px] text-ink-soft" data-id="element-160" data-mp="ep8yfd68kqzr">
              Everything you need to plan the whole thing without a planner
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-x-10 gap-y-6 px-6 sm:px-10 py-8" data-id="element-161" data-mp="3i8ttxxzovf1q">
            <ul className="space-y-2.5" data-id="element-162" data-mp="3n6v9wa1tiy8z">
              {volumeList.map(item => <li key={item} className="flex gap-2.5 text-[16px] text-ink-soft" data-id="element-163" data-mp="3ryddz6z51ey6">
                  <CheckIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-sage" aria-hidden="true" data-id="element-164" data-mp="2uihg66hrio38" />
                  {item}
                </li>)}
            </ul>
            <ul className="space-y-2.5" data-id="element-165" data-mp="2rftdwej4vph8">
              {bonusList.map(item => <li key={item} className="flex gap-2.5 text-[16px] text-ink-soft" data-id="element-166" data-mp="2mijqt5j7vpwk">
                  <GiftIcon className="w-4 h-4 mt-0.5 flex-shrink-0 text-sage" aria-hidden="true" data-id="element-167" data-mp="316ejwn14zwa6" />
                  {item}
                </li>)}
            </ul>
          </div>

          <div className="border-t border-sage/20 bg-sand px-6 sm:px-10 py-9 text-center" data-id="element-168" data-mp="28iinljfhc6dx">
            <p className="text-[14px] text-ink-soft" data-id="element-169" data-mp="23kgwcb7wh0rd">
              Total value: ${OFFER.stackedValue}
            </p>
            <p className="mt-1 text-[14px] text-clay-dark" data-id="element-170" data-mp="2ie3lp6hfgmie">
              Regular price:{' '}
              <span className="line-through" data-id="element-171" data-mp="2dfscmxyyig18">${OFFER.anchorPrice}</span>
            </p>
            <p className="mt-3 flex items-end justify-center gap-2" data-id="element-172" data-mp="3ttsam3e8rvlu">
              <span className="font-serif font-normal text-ink text-[64px] sm:text-[76px] leading-none" data-id="element-173" data-mp="3ox1trdum4vzd">
                ${OFFER.price}
              </span>
              <span className="pb-3 text-sm font-semibold text-ink-muted" data-id="element-174" data-mp="cqabon8z663">
                {OFFER.currency}
              </span>
            </p>

            <ul className="mt-5 flex flex-wrap justify-center gap-2" data-id="element-175" data-mp="3ng4upzma2kw4">
              {[`Save $${SAVINGS}`, 'One-time payment', 'Lifetime access'].map(badge => <li key={badge} className="rounded bg-sage-tint px-3 py-1 text-[12px] font-semibold uppercase tracking-kicker text-sage-deep" data-id="element-176" data-mp="j1n6jy27g8qy">
                  {badge}
                </li>)}
            </ul>

            <p className="mt-5 text-xs text-ink-muted" data-id="element-177" data-mp="e93kecpgc5aj">
              You&apos;ll be charged in your local currency.
            </p>

            <CtaButton href={OFFER.checkoutUrl} isCheckout className="mt-6 w-full" data-id="element-178" data-mp="11xmp6i9alzxv">
              Yes, I want the complete plan
            </CtaButton>
            <TrustLine className="mt-4 justify-center" data-id="element-179" data-mp="3f55t941rq9yb" />
          </div>
        </div>
      </div>
    </section>;
}